import { isContactLens } from "../../../../../../types/types/typeguards.js";
const getReviewsConfigKeys = (product, activeSku) => {
  let productId = product.masterSku;
  let variantId = activeSku;
  if (isContactLens(product)) {
    productId = product.productMasterKey;
    variantId = void 0;
  }
  return { productId, variantId };
};
export {
  getReviewsConfigKeys
};
//# sourceMappingURL=get-reviews-config-keys.js.map
